import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * RiskRecordNoteUpdate
 *
 * Assign Note to a risk record.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const RiskRecordNoteUpdate = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: { note: thePayload?.note },
      headers: {
        'x-api-endpoint': `/risk-records/${thePayload?.eid}/note`,
      },
      method: 'PUT',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/mutations/RiskRecordNoteUpdate.js -> RiskRecordNoteUpdate()',
      false,
      error
    );

    throw error;
  }
};
